import { render } from "./FormularioGMM.vue?vue&type=template&id=154b9213"
import script from "./FormularioGMM.vue?vue&type=script&lang=js"
export * from "./FormularioGMM.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__